import { makeAutoObservable, observable } from 'mobx';
import { HSObjectType } from 'shared/services/hubspot/types';
import { DataField } from 'shared/providers/types';

class HubspotStore {
  objects: HSObjectType[] = [];
  objectPropsMap = new Map<string, DataField[]>();

  constructor() {
    makeAutoObservable(this, {
      objects: observable.ref,
      objectPropsMap: observable.ref,
    });
  }

  clean() {
    this.objects = [];
    this.objectPropsMap = new Map();
  }
}

export default HubspotStore;
